import Base from "@/controllers/base";
export default class Paginate extends Base {
  constructor(elem) {
    super(elem);
  }
  init() {
    super.init();
    this.elem.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const response = await fetch(link.href, {
          headers: {
            Accept: "text/vnd.turbo-stream.html",
          },
        });
        Turbo.renderStreamMessage(await response.text());
        NApp.dispatchTurboLoad();
      });
    });
  }
}
